import { useState, createContext } from "react";

export const PopupContext = createContext();

export default function PopupContextProvider({ children }) {
  const [isBranchSelectedFromPopUp, setIsBranchSelectedFromPopUp] = useState(false);
  const [isBranchSelectedFromNavbar, setIsBranchSelectedFromNavbar] = useState(false);
  const [confirmationPopupVisibility, setConfirmationPopupVisibility] = useState(false);
  const [confirmationPopupText, setConfirmationPopupText] = useState("");
  return (
    <PopupContext.Provider
      value={{
        isBranchSelectedFromPopUp,
        setIsBranchSelectedFromPopUp,
        isBranchSelectedFromNavbar,
        setIsBranchSelectedFromNavbar,
        confirmationPopupVisibility,
        setConfirmationPopupVisibility,
        confirmationPopupText,
        setConfirmationPopupText,
      }}
    >
      {children}
    </PopupContext.Provider>
  );
}
